
<div class="input-group">
    <div class="input-group-btn">
        <span class="btn btn-default">{{title}}</span>
    </div>

    <input type="text" class="form-control" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  aria-label="...">
    <div class="input-group-btn">
        <!-- Buttons -->
        <button *ngIf='showButton' type="submit" (click)="run()" class="btn btn-default">Run</button>
    </div>
</div>